import { render, staticRenderFns } from "./SchoolTeacherAwayApplication.vue?vue&type=template&id=5990b376&scoped=true&"
import script from "./SchoolTeacherAwayApplication.vue?vue&type=script&lang=js&"
export * from "./SchoolTeacherAwayApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990b376",
  null
  
)

export default component.exports